var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartbeatp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 7.99967H13.0135C12.7221 7.99905 12.4386 8.09388 12.2062 8.26965C11.9739 8.44543 11.8055 8.69247 11.7268 8.97301L10.1602 14.5463C10.1501 14.581 10.129 14.6114 10.1002 14.633C10.0713 14.6546 10.0362 14.6663 10.0002 14.6663C9.9641 14.6663 9.92901 14.6546 9.90016 14.633C9.87131 14.6114 9.85026 14.581 9.84016 14.5463L6.16016 1.45301C6.15007 1.41839 6.12901 1.38798 6.10016 1.36634C6.07131 1.3447 6.03622 1.33301 6.00016 1.33301C5.9641 1.33301 5.92901 1.3447 5.90016 1.36634C5.87131 1.38798 5.85026 1.41839 5.84016 1.45301L4.2735 7.02634C4.19514 7.30578 4.02775 7.55202 3.79674 7.72768C3.56573 7.90335 3.28371 7.99884 2.9935 7.99967H1.3335",
    stroke: "#E10C3C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeatp);
export default __webpack_public_path__ + "static/media/heartbeatp.d6d9f0b4ea7a94e84b9c9460f2070a46.svg";
export { ForwardRef as ReactComponent };